import joinRoom from './joinRoom';
import sendMessage from './sendMessage';
import setupSocket from './setupSocket';

const IO = {
  joinRoom,
  sendMessage,
  setupSocket,
};

export default IO;
